@if (!screenService.isMobile) {
  <fa-icon [icon]="faCircleQuestion" [tooltip]="value()" [position]="position()" [size]="'lg'"></fa-icon>
}
